import { Navigate } from "react-router-dom";

const ViewAllSkills = () => {
  return <Navigate to="/all-skills/reports" replace />;
};

export default ViewAllSkills;
